<template>
  <div class="user-menu" v-if="activeUserInfo.name">
    <v-btn to="/edit-profile" text>
      <img
      alt="Profile icon"
      src="@/assets/img/profile-icon.svg"
      class="pr-2"
    />{{ activeUserInfo.name }}</v-btn>
    <v-divider
      vertical
    ></v-divider>
    <v-btn @click="logout" text>Logout</v-btn>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.getters['user/currentUser']
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
        .then(() => {
          this.$router.push('/')
          this.$store.dispatch('deals/list')
        })
        .catch(err => {
          this.$log('err', err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.user-menu {
  display: none;
  @media (min-width: 1280px) {
    display: flex;
  }
}
.username {
  white-space: nowrap;
}
</style>
